import styled from "@emotion/styled";
import React from "react";
import { formatNumber, i18n } from "src/common";
import { BarCode, Flex, Text } from 'src/components';
import { colors } from "src/theme";

const Container = styled.div({
  backgroundColor: colors.white,
  borderRadius: 12,
  border: `1px solid ${colors.border6}`,
  overflow: 'hidden',
});

const Header = styled(Flex)({
  backgroundColor: colors.primary,
  padding: '20px 48px',
});

const HeaderText = styled(Text)({
  color: colors.white,
});

const Content = styled(Flex)({
  padding: 12,
});

const BarcodeContainer = styled.div({

});

export interface BarcodeCardProps {
  key?: number;
  title?: string;
  data: any;
  paymentType: string;
}

export const BarcodeCard: React.FC<BarcodeCardProps> = ({
  title = i18n.t('components.cards.barcodeCard.title'),
  data,
  paymentType
}) => (
  <Container>
    <Header align="center" justify="space-between" wrap="wrap">
      {title && <HeaderText type="small" bold>{title}</HeaderText>}
      {(data.price || data.price === 0) && <HeaderText type="medium" bold>{`${formatNumber(paymentType === "oneTime" ? data.price : data.price / 12)}€`}</HeaderText>}
    </Header>
    <Content align="center" justify="center">
      <BarcodeContainer>
        <BarCode price={formatNumber(paymentType === "oneTime" ? data.price : data.price / 12)} userFirstName={data.customerFirstName} userLastName={data.customerLastName} userAddress={data.customerAddress} userCity={data.customerCity} oib={data.customerOib} recipient={data.recipientName} recipientAddress={data.recipientAddress} recipientCity={data.recipientCity} model={data.model} iban={data.recipientAccountNumber} description={data.description} hidden={false} />
      </BarcodeContainer>
    </Content>
  </Container>
);
